<template>
  <base-drawer :visible="drawerVisible" @close-drawer="closeDrawer" prevent-backdrop-close>
    <div class="connected-services-container">
      <transition name="fade" mode="out-in">
        <div class="component-holder" v-if="currentStep === 'service-overview'" :key="'step1'">
          <transition name="fade" mode="out-in">
            <section class="heading" v-if="!passwordEntryForConnectedService">
              <h2 class="title">{{ $t('servicesManagementPopup.title') }}</h2>
              <p class="description">{{ $t('servicesManagementPopup.description') }}</p>
            </section>
          </transition>
          <connected-services ref="connectedServices" @cancel-add="backToStepOne" @step-change="passwordEntryForConnectedService = true"/>
          <section class="action-bar">
            <base-button variant="primary" class="wide-button" @click="currentStep = 'choose-service'">{{ $t('servicesManagementPopup.addServiceButton') }}</base-button>
            <base-button variant="secondary" class="wide-button" @click="closeDrawer">{{ $t('servicesManagementPopup.goToServicesButton') }}</base-button>
          </section>
        </div>
        <div class="component-holder" v-if="currentStep === 'choose-service'" :key="'step2'">
          <connect-new-service ref="newServiceComp" @cancel-add="backToStepOne"/>
        </div>
      </transition>
    </div>
  </base-drawer>
</template>

<script>
import BaseDrawer from '@/components/base/base-drawer'
import ConnectedServices from '@/components/services/connectServices/connected-services'
import ConnectNewService from '@/components/services/connectServices/connect-new-service'
import { lsRemove } from '@/utils/localStorageController'
const steps = {
  serviceOverview: 'service-overview',
  chooseService: 'choose-service'
}

export default {
  name: 'connected-services-drawer',
  components: { ConnectNewService, ConnectedServices, BaseDrawer },
  data () {
    return {
      drawerVisible: false,
      connectedServices: [],
      recognizedServices: [],
      currentStep: '',
      passwordEntryForConnectedService: false
    }
  },
  methods: {
    closeDrawer () {
      this.drawerVisible = false
      this.$emit('refresh-side-nav')
      lsRemove('sc_firstLogin')
    },
    backToStepOne (refresh = false) {
      this.currentStep = steps.serviceOverview
      this.passwordEntryForConnectedService = false
      if (refresh) {
        // this.$refs.connectedServices.getReconnectionData()
        this.$emit('refresh-side-nav')
      }
    }
  },
  mounted () {
    this.drawerVisible = true
    this.currentStep = steps.serviceOverview
  }
}
</script>

<style scoped lang="scss">
.connected-services-container {
  height: 100%;
  color: $text;
  padding: 3.2rem 1.6rem 2.4rem;
  overflow-y: auto;

  @media (map_get($breakpoints, sm)) {
    padding: 4rem 4rem 2.4rem;
  }

  @media (map_get($breakpoints, md)) {
    padding: 4rem 8rem 2.4rem;
  }

  .component-holder {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .heading {
    flex: 0 0 auto;

    .title {
      font-size: 2.4rem;
      font-weight: 600;
      margin-bottom: .8rem;
    }

    .description {
      font-size: 1.6rem;
    }
  }

  .action-bar {
    background-color: $grey;
    padding-top: 2.4rem;
    display: flex;
    flex-direction: column;
    flex: 0 0 auto;

    @media (map_get($breakpoints, sm)) {
      flex-direction: row;
      justify-content: space-between;
    }

    .wide-button {
      min-width: 22rem;

      + .wide-button {
        margin-top: 1.6rem;
        @media (map_get($breakpoints, sm)) {
          margin-top: 0;
        }
      }
    }
  }
}
</style>
